/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { PageInfoDto } from '../models/page-info-dto';
import { vendorWorkspaceControllerActive } from '../fn/vendor-workspace/vendor-workspace-controller-active';
import { VendorWorkspaceControllerActive$Params } from '../fn/vendor-workspace/vendor-workspace-controller-active';
import { vendorWorkspaceControllerCreate } from '../fn/vendor-workspace/vendor-workspace-controller-create';
import { VendorWorkspaceControllerCreate$Params } from '../fn/vendor-workspace/vendor-workspace-controller-create';
import { vendorWorkspaceControllerDelete } from '../fn/vendor-workspace/vendor-workspace-controller-delete';
import { VendorWorkspaceControllerDelete$Params } from '../fn/vendor-workspace/vendor-workspace-controller-delete';
import { vendorWorkspaceControllerFindById } from '../fn/vendor-workspace/vendor-workspace-controller-find-by-id';
import { VendorWorkspaceControllerFindById$Params } from '../fn/vendor-workspace/vendor-workspace-controller-find-by-id';
import { vendorWorkspaceControllerGetInvitationCount } from '../fn/vendor-workspace/vendor-workspace-controller-get-invitation-count';
import { VendorWorkspaceControllerGetInvitationCount$Params } from '../fn/vendor-workspace/vendor-workspace-controller-get-invitation-count';
import { vendorWorkspaceControllerGetMyVendor } from '../fn/vendor-workspace/vendor-workspace-controller-get-my-vendor';
import { VendorWorkspaceControllerGetMyVendor$Params } from '../fn/vendor-workspace/vendor-workspace-controller-get-my-vendor';
import { vendorWorkspaceControllerGetPendingCount } from '../fn/vendor-workspace/vendor-workspace-controller-get-pending-count';
import { VendorWorkspaceControllerGetPendingCount$Params } from '../fn/vendor-workspace/vendor-workspace-controller-get-pending-count';
import { vendorWorkspaceControllerSearchByNameOrBusinessNo } from '../fn/vendor-workspace/vendor-workspace-controller-search-by-name-or-business-no';
import { VendorWorkspaceControllerSearchByNameOrBusinessNo$Params } from '../fn/vendor-workspace/vendor-workspace-controller-search-by-name-or-business-no';
import { vendorWorkspaceControllerSearchCursor } from '../fn/vendor-workspace/vendor-workspace-controller-search-cursor';
import { VendorWorkspaceControllerSearchCursor$Params } from '../fn/vendor-workspace/vendor-workspace-controller-search-cursor';
import { vendorWorkspaceControllerSearchOffset } from '../fn/vendor-workspace/vendor-workspace-controller-search-offset';
import { VendorWorkspaceControllerSearchOffset$Params } from '../fn/vendor-workspace/vendor-workspace-controller-search-offset';
import { vendorWorkspaceControllerUpdate } from '../fn/vendor-workspace/vendor-workspace-controller-update';
import { VendorWorkspaceControllerUpdate$Params } from '../fn/vendor-workspace/vendor-workspace-controller-update';
import { vendorWorkspaceControllerValidateBusinessNo } from '../fn/vendor-workspace/vendor-workspace-controller-validate-business-no';
import { VendorWorkspaceControllerValidateBusinessNo$Params } from '../fn/vendor-workspace/vendor-workspace-controller-validate-business-no';
import { VendorWorkspaceDto } from '../models/vendor-workspace-dto';

@Injectable({ providedIn: 'root' })
export class VendorWorkspaceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorWorkspaceControllerValidateBusinessNo()` */
  static readonly VendorWorkspaceControllerValidateBusinessNoPath = '/api/vendorWorkspace/businessNo';

  /**
   * 사업자 등록 정보 조회.
   *
   * 사용 가능한 사업자 등록 번호인지 조회합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerValidateBusinessNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerValidateBusinessNo$Response(params: VendorWorkspaceControllerValidateBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return vendorWorkspaceControllerValidateBusinessNo(this.http, this.rootUrl, params, context);
  }

  /**
   * 사업자 등록 정보 조회.
   *
   * 사용 가능한 사업자 등록 번호인지 조회합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerValidateBusinessNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerValidateBusinessNo(params: VendorWorkspaceControllerValidateBusinessNo$Params, context?: HttpContext): Observable<boolean> {
    return this.vendorWorkspaceControllerValidateBusinessNo$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerGetMyVendor()` */
  static readonly VendorWorkspaceControllerGetMyVendorPath = '/api/vendorWorkspace/myVendor';

  /**
   * 내 입점사 조회.
   *
   * 유저 ID를 기반으로 내 입점사를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerGetMyVendor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetMyVendor$Response(params?: VendorWorkspaceControllerGetMyVendor$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerGetMyVendor(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 입점사 조회.
   *
   * 유저 ID를 기반으로 내 입점사를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerGetMyVendor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetMyVendor(params?: VendorWorkspaceControllerGetMyVendor$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerGetMyVendor$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerGetPendingCount()` */
  static readonly VendorWorkspaceControllerGetPendingCountPath = '/api/vendorWorkspace/pending-count';

  /**
   * 대기 중인 입점사 수 조회.
   *
   * 대기 중인 입점사 수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerGetPendingCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetPendingCount$Response(params?: VendorWorkspaceControllerGetPendingCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return vendorWorkspaceControllerGetPendingCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 대기 중인 입점사 수 조회.
   *
   * 대기 중인 입점사 수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerGetPendingCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetPendingCount(params?: VendorWorkspaceControllerGetPendingCount$Params, context?: HttpContext): Observable<number> {
    return this.vendorWorkspaceControllerGetPendingCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerFindById()` */
  static readonly VendorWorkspaceControllerFindByIdPath = '/api/vendorWorkspace/{id}';

  /**
   * 입점사 ID 기반 조회.
   *
   * 입점사 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerFindById$Response(params: VendorWorkspaceControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID 기반 조회.
   *
   * 입점사 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerFindById(params: VendorWorkspaceControllerFindById$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerDelete()` */
  static readonly VendorWorkspaceControllerDeletePath = '/api/vendorWorkspace/{id}';

  /**
   * 입점사 삭제.
   *
   * 입점사를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerDelete$Response(params: VendorWorkspaceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 삭제.
   *
   * 입점사를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerDelete(params: VendorWorkspaceControllerDelete$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerUpdate()` */
  static readonly VendorWorkspaceControllerUpdatePath = '/api/vendorWorkspace/{id}';

  /**
   * 입점사 수정.
   *
   * 입점사를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerUpdate$Response(params: VendorWorkspaceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 수정.
   *
   * 입점사를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerUpdate(params: VendorWorkspaceControllerUpdate$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerGetInvitationCount()` */
  static readonly VendorWorkspaceControllerGetInvitationCountPath = '/api/vendorWorkspace/{id}/invitation-count';

  /**
   * 대기중인 초대/가입신청 내역 조회.
   *
   * 입점사 ID를 기반으로 대기중인 초대/가입신청 내역을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerGetInvitationCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetInvitationCount$Response(params: VendorWorkspaceControllerGetInvitationCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return vendorWorkspaceControllerGetInvitationCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 대기중인 초대/가입신청 내역 조회.
   *
   * 입점사 ID를 기반으로 대기중인 초대/가입신청 내역을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerGetInvitationCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerGetInvitationCount(params: VendorWorkspaceControllerGetInvitationCount$Params, context?: HttpContext): Observable<number> {
    return this.vendorWorkspaceControllerGetInvitationCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerSearchByNameOrBusinessNo()` */
  static readonly VendorWorkspaceControllerSearchByNameOrBusinessNoPath = '/api/vendorWorkspace/search/vendor';

  /**
   * 입점사 검색.
   *
   * 입점사 이름 또는 사업자 등록번호로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerSearchByNameOrBusinessNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchByNameOrBusinessNo$Response(params: VendorWorkspaceControllerSearchByNameOrBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceDto>>> {
    return vendorWorkspaceControllerSearchByNameOrBusinessNo(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 검색.
   *
   * 입점사 이름 또는 사업자 등록번호로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerSearchByNameOrBusinessNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchByNameOrBusinessNo(params: VendorWorkspaceControllerSearchByNameOrBusinessNo$Params, context?: HttpContext): Observable<Array<VendorWorkspaceDto>> {
    return this.vendorWorkspaceControllerSearchByNameOrBusinessNo$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorWorkspaceDto>>): Array<VendorWorkspaceDto> => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerSearchOffset()` */
  static readonly VendorWorkspaceControllerSearchOffsetPath = '/api/vendorWorkspace/search/offset';

  /**
   * 입점사 오프셋 기반 검색.
   *
   * 입점사를 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchOffset$Response(params: VendorWorkspaceControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<VendorWorkspaceDto>;
'pageInfo'?: PageInfoDto;
}>> {
    return vendorWorkspaceControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 오프셋 기반 검색.
   *
   * 입점사를 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchOffset(params: VendorWorkspaceControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items'?: Array<VendorWorkspaceDto>;
'pageInfo'?: PageInfoDto;
}> {
    return this.vendorWorkspaceControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'items'?: Array<VendorWorkspaceDto>;
'pageInfo'?: PageInfoDto;
}>): {
'items'?: Array<VendorWorkspaceDto>;
'pageInfo'?: PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerSearchCursor()` */
  static readonly VendorWorkspaceControllerSearchCursorPath = '/api/vendorWorkspace/search/cursor';

  /**
   * 입점사 커서 기반 검색.
   *
   * 입점사를 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchCursor$Response(params: VendorWorkspaceControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<VendorWorkspaceDto>;
}>> {
    return vendorWorkspaceControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 커서 기반 검색.
   *
   * 입점사를 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceControllerSearchCursor(params: VendorWorkspaceControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<VendorWorkspaceDto>;
}> {
    return this.vendorWorkspaceControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<VendorWorkspaceDto>;
}>): CursorPaginationDto & {
'items'?: Array<VendorWorkspaceDto>;
} => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerCreate()` */
  static readonly VendorWorkspaceControllerCreatePath = '/api/vendorWorkspace';

  /**
   * 입점사 생성.
   *
   * 입점사를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerCreate$Response(params: VendorWorkspaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 생성.
   *
   * 입점사를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerCreate(params: VendorWorkspaceControllerCreate$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceControllerActive()` */
  static readonly VendorWorkspaceControllerActivePath = '/api/vendorWorkspace/{id}/active';

  /**
   * 입점사 활성화.
   *
   * 입점사를 활성화합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceControllerActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerActive$Response(params: VendorWorkspaceControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
    return vendorWorkspaceControllerActive(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 활성화.
   *
   * 입점사를 활성화합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceControllerActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceControllerActive(params: VendorWorkspaceControllerActive$Params, context?: HttpContext): Observable<VendorWorkspaceDto> {
    return this.vendorWorkspaceControllerActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceDto>): VendorWorkspaceDto => r.body)
    );
  }

}
